<template>
  <div class="col-block flex-start">
    <div v-for="(data, index) in datas" :key="index">{{ data }}</div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // param
    datas () {
      return (this.param || {}).datas || []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/borCor/demo.vue